import React from "react";
import { assets } from "../assets/assets_frontend/assets";
const Footer = () => {
  return (
    <div className="md:mx-10">
      <div className=" flex flex-col gap-14 my-10 mt-40 text-sm md:grid grid-cols-[3fr,1fr,1fr]">
        <div className="">
          <img  className="mb-5 w-45"src={assets.logo} alt="Egf" />
          <p className=" w-full leading-6 text-gray-600 md:w-2/3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam
            sed, corporis iusto maxime cupiditate reprehenderit aliquid
            molestias iste quaerat deleniti!
          </p>
        </div>
        <div className="">
          <h1 className="text-xl font-medium mb-5">company</h1>
          <ul className="flex flex-col text-gray-600 gap-2">
            <li>home</li>
            <li>about us</li>
            <li>contact</li>
            <li>privacy policy</li>
          </ul>
        </div>
        <div >
          <h1 className="text-xl font-medium mb-5">get in touch</h1>
          <ul className="text-gray-600 flex flex-col leading-6">
            <li>+0201117646588</li>
            <li>ebraheemgaber222@gmail.com</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
